<template>
  <div>
    <p class="text-muted">
      The event starts on <br />
      <template v-if="userTimezone === eventTimezone">
        <span>{{ formattedEventDate }} ({{ eventTimezone }})</span>
      </template>
      <template v-else-if="isTzSameDay">
        <span>{{ formattedUserEventDate }} ({{ userTimezone }})</span> /
        <span>{{ formattedEventDate.split(EVENT_DATE_DELIMITER)[1] }} ({{ eventTimezone }})</span>
      </template>
      <template v-else>
        <span>{{ formattedUserEventDate }} ({{ userTimezone }})</span><br />
        <span>{{ formattedEventDate }} ({{ eventTimezone }})</span>
      </template>
    </p>
    <ul class="countdown-container">
      <li class="countdown-container__item"><CountdownTimerRing :value="days" :max-value="365" label="days" /></li>
      <li class="countdown-container__item"><CountdownTimerRing :value="hours" :max-value="24" label="hours" /></li>
      <li class="countdown-container__item"><CountdownTimerRing :value="minutes" :max-value="60" label="minutes" /></li>
      <li class="countdown-container__item"><CountdownTimerRing :value="seconds" :max-value="60" label="seconds" /></li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
import CountdownTimerRing from "./CountdownTimerRing";
import { mapGetters, mapState } from "vuex";
import dayjs from "dayjs";

const MILLISECONDS_SECOND = 1000;
const MILLISECONDS_MINUTE = 60 * MILLISECONDS_SECOND;
const MILLISECONDS_HOUR = 60 * MILLISECONDS_MINUTE;
const MILLISECONDS_DAY = 24 * MILLISECONDS_HOUR;

export default {
  name: "CountdownTimer",
  components: {
    CountdownTimerRing
  },
  data() {
    return {
      EVENT_DATE_DELIMITER: ", "
    };
  },
  computed: {
    ...mapState("event", {
      nodeContext: "context"
    }),
    ...mapState("config", ["millisecondsToEvent"]),
    ...mapGetters("config", ["eventStartDate", "eventTimezone"]),
    /** Remaining days */
    days() {
      return Math.floor(this.millisecondsToEvent / MILLISECONDS_DAY);
    },
    /** Remaining hours */
    hours() {
      return Math.floor((this.millisecondsToEvent % MILLISECONDS_DAY) / MILLISECONDS_HOUR);
    },
    /** Remaining minutes */
    minutes() {
      return Math.floor((this.millisecondsToEvent % MILLISECONDS_HOUR) / MILLISECONDS_MINUTE);
    },
    /** Remaining seconds */
    seconds() {
      return Math.floor((this.millisecondsToEvent % MILLISECONDS_MINUTE) / MILLISECONDS_SECOND);
    },

    /** Format string for event date */
    eventDateFormatString() {
      return `D MMMM YYYY${this.EVENT_DATE_DELIMITER}HH:mm`;
    },
    /** Formatted string for event start date in event timezone */
    formattedEventDate() {
      return this.eventStartDate.tz(this.eventTimezone).format(this.eventDateFormatString);
    },
    /** Formatted string for event start date in user timezone */
    formattedUserEventDate() {
      return this.eventStartDate.tz(this.userTimezone).format(this.eventDateFormatString);
    },
    /** Is user timezoned start day the same as event timezoned */
    isTzSameDay() {
      return (
        this.formattedEventDate.split(this.EVENT_DATE_DELIMITER)[0] ===
        this.formattedUserEventDate.split(this.EVENT_DATE_DELIMITER)[0]
      );
    },
    /** User timezone */
    userTimezone() {
      return dayjs.tz.guess();
    }
  }
};
</script>

<style>
.countdown-container {
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  max-width: 420px;
  margin: 0 auto;
}
.countdown-container__item {
  list-style: none;
}

@media (max-width: 500px) {
  .countdown-container {
    padding: 5px;
  }
}
</style>
